import { getWidth } from "../common";

// skipping 7, 14
// https://dd-is.atlassian.net/browse/OMEMCDEV-2359
const column_headers = [1, 2, 3, 4, 5, 6, 8, 9, 10, 11, 12, 13, 15, 16];
export default column_headers.map((current) => {
  const field = `switch_basic_${current}`;
  return {
    field,
    label: field,
    width: getWidth(column_headers.length),
    isSortable: false,
    isCSV: true,
  };
});
